import * as types from './currentUser/actionTypes';

export const CLEAR_REDUX_STATE = "state/clear";

export const clearState = () => async (dispatch) => {
    dispatch({ type: CLEAR_REDUX_STATE });
}